<script setup lang="ts">
const siteStore = useSiteStore();

const enableFade = computed(() => {
  return siteStore.bannerDevConfig.enableFade ?? false;
});
</script>

<template>
  <div
    :class="[
      'relative',
      {
        'px-1 dark:px-0': enableFade,
      },
    ]"
  >
    <slot />
    <span
      class="absolute w-full bottom-0 left-0 h-[0] dark:h-[35%]"
      :class="{
        'bg-gradient-to-b from-transparent to-light-100 dark:to-dark-900 z-1':
          enableFade,
      }"
    />
  </div>
</template>
